import React from 'react';
import './styles.less';

export function Overlay({className = '', children}) {
    return (
        <div className={`overlay ${className}`}>
            {children}
        </div>
    );
}
